import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import "./our_pricing.css";
import Header from "../header";
import Footer from "../footer";
const OurPricing = () => {

	const [pricingData, setPricingData] = useState([])
	const [pricingOfferData, setPricingOfferData] = useState([])
	const [pricingOfferLengthData, setPricingOfferLengthData] = useState([])

	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		fetchPricingData();
		fetchPricingOfferData();
	}, []);

	const fetchPricingData = async () => {
		const response = await fetch(
			`https://api.dhobicart.in/pricelist/api/website-price/E82THEM/rate-list`
		);

		const data = await response.json();

		if (!response.ok) {
			throw new Error(data.message || "Failed to fetch pricing");
		}

		// Group by service name
		const groupedData = data.reduce((acc, item) => {
			const service = item.brandAppServiceName;
			if (!acc[service]) acc[service] = [];
			acc[service].push(item);
			return acc;
		}, {});

		setPricingData(groupedData);
	};


	console.log("pricingData", pricingData)


	const filterData = (groupedData, searchTerm) => {
		if (!searchTerm) return groupedData;

		const searchLower = searchTerm.toLowerCase();
		const filteredResult = {};

		Object.entries(groupedData).forEach(([serviceName, items]) => {
			const filteredItems = items.filter((item) =>
				Object.values(item).some((value) =>
					typeof value === "string" || typeof value === "number"
						? value.toString().toLowerCase().includes(searchLower)
						: false
				)
			);

			if (filteredItems.length > 0) {
				filteredResult[serviceName] = filteredItems;
			}
		});

		return filteredResult;
	};


	const filteredOrderInfoData = filterData(pricingData, searchTerm);

	const handleClearSearch = () => {
		setSearchTerm("");
	};

	const fetchPricingOfferData = async () => {


		const response = await fetch(
			`https://api.dhobicart.in/pricelist/api/website-price/E82THEM/offer`,
			{
				method: "GET",
				headers: { "Content-Type": "application/json" },
			},
		);


		const data = await response.json();
		setPricingOfferData(data)
		// ✅ Only first 4 items
		setPricingOfferLengthData(data.slice(0, 4));


		if (!response.ok) {
			throw new Error(data.message || "DhobiCart login failed");
		}


		return data;
	};

	return (
		<div>
			<Header />
			<div className="pricingBannerInfo">
				<div className="priceBnrN">
					<div className="container">
						<div className="pricingBnr">
							<h2>OUR <br /> PRICING</h2>
							<p>SAVE 25% ON YOUR FIRST ORDER WITH CODE TML25X</p>
							<div className="browswPrices">
								<a href="#offer">Browse our prices</a>
								<div className="downArrow"><a href="#offer" style={{ padding: 0, margin: 0 }}><img src="./images/downArrow.png" /></a></div>
							</div>
						</div>
					</div>
				</div>
				<div className="pricedataManin">
					<div className="container">
						<div className="offerInfo">
							<h3>Offers</h3>
							<div className="cardPriceInfo">
								{pricingOfferLengthData.map((item) => (
									<div className="cardDataNew">
										<div className="leftCardNew">
											<table>
												<tr><td className="bgData"></td><td>{item.amount}  INR</td></tr>
											</table>
										</div>
										<div className="leftCardNew">
											<table>
												<tr><td colSpan={"2"}>{item.name} ({item.appService})</td></tr>
											</table>
										</div>
									</div>
								))}

								<div className="cntdatanew">
									<p>OUR MINIMUM ORDER IS 650 INR. YOU CAN PLACE AN ORDER FOR LESS THAN THIS AMOUNT, BUT IT WILL BE ROUNDED UP TO THE MINIMUM RATE</p>
									<p>OF 650 INR</p>
									<p>If your garment is not listed below, please contact our customer service team for more information.</p>
								</div>
								<div className="IndivusualInfo" id="offer">
									<h3>INDIVIDUAL GARMENTS</h3>
									<p>( COST PER PIECE )</p>

									<div className="rowInput" style={{display:"flex"}}>
										<input
											type="text"
											value={searchTerm}
											onChange={(e) => setSearchTerm(e.target.value)}
											placeholder="Search Garment Here"
											maxLength={50}
											required
										/>
									</div>

									{Object.entries(filteredOrderInfoData).map(([serviceName, items]) => (
										<div key={serviceName} className="serviceTable">
											<h3 className="my-4">{serviceName === "STEAM IRON" ? "STEAM PRESS" : serviceName}</h3>

											<table>
												<tr>
													<td>Items</td>
													<td>Amount</td>
												</tr>

												{items.map((item, index) => (
													<tr key={`${serviceName}-${index}`}>
														<td>
															{item.garmentName} ({item.categoryName})
														</td>
														<td>{item.amount} INR</td>
													</tr>
												))}
											</table>
										</div>
									))}
								</div>
								<div className="IndivusualInfo">
									<h3>OFFERS</h3>
									<p>( CLEANING AND STEAM PRESS )</p>
									<table>
										{pricingOfferData.map((item) => (
											<tr>
												<td>{item.name}</td>
												<td>{item.amount} INR</td>
											</tr>
										))}
									</table>
								</div>
							</div>
						</div>
						<div className="bookNowInfo"> <NavLink to="/book_now"><img alt="Book Now" src="./images/bookNow.png" /></NavLink></div>
						<div className="tearmsCondition">
							<h4>Terms & Conditions:-</h4>
							<p>-Minimum Order Value: -A minimum order of 650 INR is required for all services. </p>
							<p>-White Garment Surcharge: -An additional charge of 20 INR per white garment applies for specialized care and treatment.</p>
							<p> -GST Applicable: -All listed prices are exclusive of 18% GST, which will be added to the final bill.</p>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default OurPricing;
